import React from "react";
import { TextField } from "react-admin";

const NameEnField = ({ sortable = false }) => {
  return (
    <TextField
      source="nameEn"
      sortable={sortable}
    />
  );
};

export default NameEnField;
